/** Premium financing add-on, above the quotes page cross-sell. */
export function PremiumFinancingBanner() {
  return (
    <div className="flex flex-col items-start gap-3">
      <span className="eyebrow">Add ons</span>
      <h2 className="text-ink text-2xl font-bold tracking-tight">Looking for down payment support?</h2>
      <p className="text-ink-500 text-md max-w-[60ch]">
        Cai can connect you to the biggest names in premium financing, like Imperial PFS, First Insurance
        Funding, Lendio, and more. Ask your broker during checkout!
      </p>
    </div>
  )
}
